import gql from 'graphql-tag';

const getAccountCardPreviewDownloadFileQuery = gql`
  query getAccountCardPreviewDownloadFileQuery($id: RecordID!) {
    accountCard(id: $id) {
      id
      front_preview_file_download_url
    }
  }
`;

export default getAccountCardPreviewDownloadFileQuery;
